import Vue           from 'vue';
import Router        from 'vue-router';
import People        from './pods/people/component.vue';
import Funnels       from './pods/funnels/component.vue';
import Funnel        from './pods/funnels/show.vue';
import Attributes    from './pods/attributes/component.vue';
import Queue         from './pods/queue/component.vue';
import Knowledgebase from './pods/knowledgebase/component.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/settings/attributes',
      name: 'settings',
      component: Attributes,
      props: true
    },
    {
      path: '/settings/queue',
      name: 'queue',
      component: Queue,
      props: true
    },
    {
      path: '/funnels/:id',
      name: 'funnel',
      component: Funnel,
      props: true
    },
    {
      path: '/funnels',
      name: 'funnels',
      component: Funnels,
      props: true
    },
    {
      path: '/knowledgebase',
      name: 'knowledgebase',
      component: Knowledgebase,
      props: true
    },
    {
      path: '/',
      name: 'people',
      component: People,
      props: true
    }
  ]
})
